import type { Breakpoint, DialogProps } from '@mui/material'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, LinearProgress } from '@mui/material'
import type { FC } from 'react'
import React from 'react'
import { DialogTitle } from './dialog-title.js'

export interface ConfirmDialogProps extends DialogProps {
  className?: string
  open: boolean
  title?: string
  /** Busy - disable all inputs / buttons and show a progress bar */
  busy?: boolean
  // OK button is enabled
  enabled?: boolean
  okText?: string
  cancelText?: string
  text: string
  maxWidth?: false | Breakpoint | undefined

  onCancel(ev: React.SyntheticEvent): void
  onConfirm(ev: React.SyntheticEvent): void
}

export const ConfirmDialog: FC<ConfirmDialogProps> = props => {
  const {
    children,
    text,
    busy = false,
    open,
    okText = 'OK',
    cancelText = 'Cancel',
    enabled = true,
    onConfirm,
    onCancel,
    title = 'Confirm',
    ...restProps
  } = props

  if (!open) {
    return null
  }
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      onClick={ev => ev.stopPropagation()}
      {...restProps}
    >
      <DialogTitle onClose={onCancel} id="alert-dialog-title">
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{text}</DialogContentText>
        {children}

        {busy ? <LinearProgress sx={{ mt: 2 }} /> : null}
      </DialogContent>
      <DialogActions>
        <Button disabled={busy} onClick={onCancel}>
          {cancelText}
        </Button>
        <Button disabled={busy || !enabled} onClick={onConfirm} autoFocus={true}>
          {okText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmDialog
